import React from 'react'

export type ProductType = 'bottle' | 'can' | 'pen' | 'spray' | 'tin'

/** Placeholder product drawing from the prototype (`art()` in app.js), until real photos exist. */
export const ProductArt: React.FC<{ type: ProductType; color?: string }> = ({
  type,
  color = '#143e71',
}) => {
  const narrow = type === 'spray'
  const x = narrow ? 45 : 30
  const w = narrow ? 60 : 90

  return (
    <svg
      aria-label="Illustrazione prodotto"
      viewBox="0 0 150 210"
      xmlns="http://www.w3.org/2000/svg"
    >
      {type === 'spray' && (
        <>
          <rect fill="#e1e6e5" height="28" rx="5" width="44" x="53" y="13" />
          <rect fill="#a3b1b5" height="10" rx="2" width="18" x="65" y="6" />
        </>
      )}
      {type === 'bottle' && <rect fill="#142e46" height="31" rx="3" width="40" x="55" y="10" />}
      {type === 'pen' && (
        <>
          <rect fill="#d0d9dc" height="37" rx="4" width="20" x="45" y="10" />
          <rect fill="#d0d9dc" height="37" rx="4" width="20" x="85" y="10" />
        </>
      )}
      {(type === 'can' || type === 'tin') && (
        <>
          <ellipse cx="75" cy="40" fill="#aebbc0" rx="47" ry="10" />
          <ellipse cx="75" cy="37" fill="#e4e9e9" rx="45" ry="7" />
        </>
      )}
      {type === 'pen' ? (
        <>
          <rect fill="#f9fbfc" height="149" rx="7" stroke="#becbd0" width="26" x="42" y="45" />
          <rect fill="#f9fbfc" height="149" rx="7" stroke="#becbd0" width="26" x="82" y="45" />
          <rect fill={color} height="78" width="24" x="43" y="76" />
          <rect fill="#8299ad" height="78" width="24" x="83" y="76" />
          <rect fill="#ed6b35" height="8" width="24" x="43" y="144" />
          <rect fill="#ed6b35" height="8" width="24" x="83" y="144" />
        </>
      ) : (
        <>
          <rect
            fill="#e4ebed"
            height="151"
            rx="9"
            stroke="#aebec4"
            width={narrow ? 62 : 92}
            x={narrow ? 44 : 29}
            y="40"
          />
          <rect fill="#fcfdfb" height="102" width={w} x={x} y="65" />
          <rect fill={color} height="44" width={w} x={x} y="99" />
          <rect fill="#ed6b35" height="7" width={w} x={x} y="140" />
          <text
            fill="#143e71"
            fontFamily="Arial"
            fontSize="8"
            fontWeight="bold"
            textAnchor="middle"
            x="75"
            y="83"
          >
            VERNICISUBITO
          </text>
          <text fill="white" fontFamily="Arial" fontSize="9" textAnchor="middle" x="75" y="120">
            {type === 'spray' ? 'SPRAY' : type === 'tin' ? 'COLORE' : 'PRO'}
          </text>
          <text fill="#647c89" fontFamily="Arial" fontSize="5" textAnchor="middle" x="75" y="160">
            IL TUO PROGETTO
          </text>
        </>
      )}
    </svg>
  )
}
